
import React from 'react';
import { cn } from "@/lib/utils";

interface EmojiButtonProps {
  emoji: string;
  label: string;
  isSelected?: boolean;
  onClick?: () => void;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const EmojiButton: React.FC<EmojiButtonProps> = ({
  emoji,
  label,
  isSelected = false,
  onClick,
  className,
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'text-xl py-2 px-3',
    md: 'text-2xl py-3 px-4',
    lg: 'text-3xl py-4 px-6'
  };

  return (
    <button
      onClick={onClick}
      className={cn(
        'flex flex-col items-center rounded-xl transition-all duration-200',
        'border border-surface-border hover:border-primary-200 bg-white',
        'hover:shadow-md focus:ring-2 focus:ring-primary-100 focus:outline-none',
        isSelected && 'border-primary-300 shadow-md bg-primary-50',
        sizeClasses[size],
        className
      )}
    >
      <span className="mb-1">{emoji}</span>
      <span className="text-xs font-medium text-text-secondary">{label}</span>
    </button>
  );
};

export default EmojiButton;
